import styled from "styled-components/macro";

export const ErrorMessage = styled.div`
  text-align: right;
  color: red;
  font-size: 0.75em;
  padding: 0.5em 0 0.5em 0;
`;
